"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./html"));
__export(require("./visitor"));
__export(require("./util"));
exports.t = m => m[0].map((x, i) => m.map(x => x[i]));
/*
    export abstract class UiNode
    {
        args: {
            UiNode stuff +
                parent: UiNode
                model: {},

            transformation: {},
            plexxCss : {}
        }

        constructor()
        {
        }

        updateModel() {}
        updateViewModel(sel:[string]) {}

        updateAll() {}
    }
*/



//////////////////
// WEBPACK FOOTER
// ../ducd/dist/js/index.js
// module id = 4
// module chunks = 0